import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import CustomBody from "../CustomBody/index";
import { CustomButton } from "../../../Forms";

//Assets
import LogisticParcelIcon from "../../../../images/logistic-parcel.png";

//Interface
import { WrapperAndComponentInterface } from "./definitions";

const WrapperAndComponent: FC<WrapperAndComponentInterface> = ({
  toPickupAddress,
  toDeliveryMethod
}) => {
  return (
    <CustomBody withBack backAction={toPickupAddress}>
      <div className="out-of-react-body">
        <KickImage className="out-of-react-img" src={LogisticParcelIcon} alt="pickup-address" />
        <p className="header">Your Address is Out of Reach.</p>
        <p className="info">No delivery options are available for this address, you could try <br /> putting in different address, or pick another delivery method.</p>
        <div className="button-wrapper">
          <CustomButton text="Change Address" onClick={() => toPickupAddress()} className="first-button" disabled={false} />
          <CustomButton text="Change Method" onClick={() => toDeliveryMethod()} disabled={false} />
        </div>
      </div>
    </CustomBody>
  )
}

export default WrapperAndComponent